/** Method key for the `@connected` hook that publishes `role="none"` on `internals` (see `presentational.ts`). */
export const presentational = Symbol('presentational')
